import { createStyles, makeStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles(function () {
    return createStyles({
        text: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline-block',
            width: 'inherit',
        },
    });
});
//# sourceMappingURL=OverflowTooltip.styles.js.map